import { render } from "./OilPriceLogForm.vue?vue&type=template&id=713f6e2b&scoped=true&ts=true"
import script from "./OilPriceLogForm.vue?vue&type=script&lang=ts"
export * from "./OilPriceLogForm.vue?vue&type=script&lang=ts"

import "./OilPriceLogForm.vue?vue&type=style&index=0&id=713f6e2b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713f6e2b"]])

export default __exports__